import { render, staticRenderFns } from "./ProductCarouselSwiper.vue?vue&type=template&id=431d0944"
import script from "./ProductCarouselSwiper.vue?vue&type=script&lang=js"
export * from "./ProductCarouselSwiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports